import React, { FC } from 'react';
import { FormikHandlers } from 'formik';
import Select from '../../../../library/inputs/select/SelectInput';
import { CultureTextModel } from '../../../../../models/form/form';

interface Props {
  id: string;
  value: string | undefined;
  options: Array<{ text: CultureTextModel[] | string; value: string }> | undefined;
  handleBlur: FormikHandlers['handleBlur'];
  handleChange: FormikHandlers['handleChange'];
  placeholder: string | undefined;
  readOnlyMode?: boolean;
  culture?: string;
}

const SelectField: FC<Props> = ({
  id,
  value,
  options,
  handleBlur,
  handleChange,
  placeholder,
  readOnlyMode,
  culture,
}: Props) => {
  return (
    <Select
      id={id}
      onChange={handleChange}
      onBlur={handleBlur}
      value={value}
      options={options}
      placeholder={placeholder}
      readOnlyMode={readOnlyMode}
      culture={culture}
    />
  );
};

export default SelectField;
